// US State wakeup levels - generated by scripts/generateStateWakeupLevels.ts
// Wakeup levels 0-5:
// 0 = not aware
// 1 = top 10 issue (e.g., regulating social media)
// 2 = top 3 issue (e.g., trump immigration policy)
// 3 = top urgent issue (e.g., covid response)
// 4 = emergency response (e.g., 9/11)
// 5 = wartime level (e.g., WW2)
import { useMemo } from "react"
import { makeLevels, getWakeupLevelFromLevels } from "./wakeupTypes"
export type StateWakeupData = {
  state: string
  label?: string
  levels: { date: string; level: number }[]
}
export const stateWakeupLevels: StateWakeupData[] = [
  { state: 'California', levels: makeLevels([2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'District of Columbia', levels: makeLevels([0, 2, 4, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Massachusetts', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Washington', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'New York', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Virginia', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Colorado', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Texas', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Illinois', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'New Jersey', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Connecticut', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Oregon', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Arizona', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Georgia', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'North Carolina', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Pennsylvania', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Utah', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Nevada', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Michigan', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Ohio', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Alabama', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Alaska', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Arkansas', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Delaware', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Florida', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Hawaii', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Idaho', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Indiana', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Iowa', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Kansas', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Kentucky', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Louisiana', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Maine', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Minnesota', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Mississippi', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Missouri', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Montana', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Nebraska', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'New Hampshire', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'New Mexico', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'North Dakota', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Oklahoma', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Rhode Island', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'South Carolina', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'South Dakota', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Tennessee', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Vermont', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'West Virginia', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Wisconsin', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
  { state: 'Wyoming', levels: makeLevels([0, 0, 2, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5]) },
]
export type StateWakeup = { state: string; label: string; level: number }
// Get all state wakeup levels for a specific date
export function getStateWakeupsForDate(targetDate: Date): StateWakeup[] {
  const result = stateWakeupLevels.map(s => ({
    state: s.state,
    label: s.label ?? s.state,
    level: getWakeupLevelFromLevels(s.levels, targetDate)
  }))
  // If DC is highlighted, also highlight Maryland with the same wakeup level
  const dcWakeup = result.find(s => s.state === 'District of Columbia')
  if (dcWakeup && dcWakeup.level > 0) {
    result.push({ state: 'Maryland', label: 'Maryland', level: dcWakeup.level })
  }
  return result
}
export const useStateWakeup = (currentDate: Date) => {
  return useMemo(() => getStateWakeupsForDate(currentDate), [currentDate])
}
